import { Button } from '../ui';

export function OptionalSetForm({
  exercise,
  setIndex,
  data,
  onUpdate,
  onApplyToSet2,
  onApplyToSet3,
  showApplyToSet2,
  showApplyToSet3,
}) {
  const updateField = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  // Check if there's data to apply
  const hasDataToApply = Object.keys(data).some(key => key !== 'notes' && data[key]);

  return (
    <div className="space-y-4">
      {/* Reps - with side logic */}
      {exercise.hasReps && (
        exercise.hasSide ? (
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Left Reps
              </label>
              <input
                type="number"
                value={data.leftReps || ''}
                onChange={(e) => updateField('leftReps', e.target.value ? parseInt(e.target.value) : '')}
                placeholder="Reps"
                min="0"
                className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Right Reps
              </label>
              <input
                type="number"
                value={data.rightReps || ''}
                onChange={(e) => updateField('rightReps', e.target.value ? parseInt(e.target.value) : '')}
                placeholder="Reps"
                min="0"
                className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
              />
            </div>
          </div>
        ) : (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Reps
            </label>
            <input
              type="number"
              value={data.reps || ''}
              onChange={(e) => updateField('reps', e.target.value ? parseInt(e.target.value) : '')}
              placeholder="Enter reps"
              min="0"
              className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
            />
          </div>
        )
      )}

      {/* Hold Time - with side logic */}
      {exercise.hasHoldTime && (
        exercise.hasSide ? (
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Left Hold (sec)
              </label>
              <input
                type="number"
                value={data.leftHoldTime || ''}
                onChange={(e) => updateField('leftHoldTime', e.target.value ? parseInt(e.target.value) : '')}
                placeholder="Seconds"
                min="0"
                className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Right Hold (sec)
              </label>
              <input
                type="number"
                value={data.rightHoldTime || ''}
                onChange={(e) => updateField('rightHoldTime', e.target.value ? parseInt(e.target.value) : '')}
                placeholder="Seconds"
                min="0"
                className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
              />
            </div>
          </div>
        ) : (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Hold Time (seconds)
            </label>
            <input
              type="number"
              value={data.holdTime || ''}
              onChange={(e) => updateField('holdTime', e.target.value ? parseInt(e.target.value) : '')}
              placeholder="Enter seconds"
              min="0"
              className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
            />
          </div>
        )
      )}

      {/* Weight - with side logic */}
      {exercise.hasWeight && (
        exercise.hasSide ? (
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Left Weight (lbs)
              </label>
              <input
                type="number"
                step="0.5"
                value={data.leftWeight || ''}
                onChange={(e) => updateField('leftWeight', e.target.value ? parseFloat(e.target.value) : '')}
                placeholder="Weight"
                min="0"
                className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Right Weight (lbs)
              </label>
              <input
                type="number"
                step="0.5"
                value={data.rightWeight || ''}
                onChange={(e) => updateField('rightWeight', e.target.value ? parseFloat(e.target.value) : '')}
                placeholder="Weight"
                min="0"
                className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
              />
            </div>
          </div>
        ) : (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Weight (lbs)
            </label>
            <input
              type="number"
              step="0.5"
              value={data.weight || ''}
              onChange={(e) => updateField('weight', e.target.value ? parseFloat(e.target.value) : '')}
              placeholder="Enter weight"
              min="0"
              className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400"
            />
          </div>
        )
      )}

      {/* Notes */}
      {exercise.hasNotes && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notes (optional)
          </label>
          <textarea
            value={data.notes || ''}
            onChange={(e) => updateField('notes', e.target.value)}
            placeholder="Any additional notes..."
            rows={2}
            className="block w-full px-3 py-2.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary placeholder:text-gray-400 resize-none"
          />
        </div>
      )}

      {/* Apply to Other Sets - Separate Toggles */}
      {hasDataToApply && (showApplyToSet2 || showApplyToSet3) && (
        <div className="pt-2 space-y-2">
          {showApplyToSet2 && (
            <button
              type="button"
              onClick={onApplyToSet2}
              className="w-full flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:border-primary hover:bg-primary/5 transition-colors"
            >
              <span className="text-sm font-medium text-gray-700">Apply to Set 2</span>
              <div className="h-5 w-5 rounded border-2 border-primary flex items-center justify-center">
                <svg className="h-3 w-3 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </button>
          )}
          {showApplyToSet3 && (
            <button
              type="button"
              onClick={onApplyToSet3}
              className="w-full flex items-center justify-between p-3 rounded-lg border border-gray-200 hover:border-primary hover:bg-primary/5 transition-colors"
            >
              <span className="text-sm font-medium text-gray-700">Apply to Set 3</span>
              <div className="h-5 w-5 rounded border-2 border-primary flex items-center justify-center">
                <svg className="h-3 w-3 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </button>
          )}
        </div>
      )}

      {/* Empty state for exercises with only notes */}
      {!exercise.hasSide && !exercise.hasReps && !exercise.hasHoldTime && !exercise.hasWeight && (
        <div className="text-center py-4 text-gray-500">
          <p className="text-sm">
            This exercise only requires notes documentation.
          </p>
        </div>
      )}
    </div>
  );
}